"use strict";

exports.__esModule = true;
exports.DescriptionList = DescriptionList;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Displays a list of terms and descriptions.
 */
function DescriptionList(props) {
  return /*#__PURE__*/_react["default"].createElement("dl", props);
}